// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1B4rM","item":"PaymentsMobile_item__2pzk4","label":"PaymentsMobile_label__2RNr7","amount":"PaymentsMobile_amount__dLsio"};